import { Component, Input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-driver-call-status',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './driver-call-status.component.html',
  styleUrl: './driver-call-status.component.scss'
})
export class DriverCallStatusComponent {
  @Input() callResult: string | null = null;
  @Input() driverStatus: string | null = null;
}